import InterSemiBoldText from './InterSemiBoldText';

export default InterSemiBoldText;
